package com.evoapps.evoshift.ui.courses

import androidx.compose.foundation.background
import androidx.compose.foundation.border
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.ColumnScope
import androidx.compose.foundation.layout.FlowRow
import androidx.compose.foundation.layout.PaddingValues
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.size
import androidx.compose.foundation.layout.width
import androidx.compose.foundation.rememberScrollState
import androidx.compose.foundation.selection.selectable
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.foundation.verticalScroll
import androidx.compose.material.icons.Icons
import androidx.compose.material.icons.filled.Autorenew
import androidx.compose.material.icons.filled.Badge
import androidx.compose.material.icons.filled.CheckCircle
import androidx.compose.material.icons.filled.Description
import androidx.compose.material.icons.filled.Edit
import androidx.compose.material.icons.filled.EditNote
import androidx.compose.material.icons.filled.Engineering
import androidx.compose.material.icons.filled.HealthAndSafety
import androidx.compose.material.icons.filled.Info
import androidx.compose.material.icons.filled.PictureAsPdf
import androidx.compose.material.icons.filled.School
import androidx.compose.material3.Button
import androidx.compose.material3.CircularProgressIndicator
import androidx.compose.material3.Icon
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.OutlinedButton
import androidx.compose.material3.RadioButton
import androidx.compose.material3.Scaffold
import androidx.compose.material3.SnackbarHost
import androidx.compose.material3.SnackbarHostState
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.vector.ImageVector
import androidx.compose.ui.platform.LocalUriHandler
import androidx.compose.ui.semantics.Role
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.unit.dp
import androidx.lifecycle.compose.collectAsStateWithLifecycle
import com.evoapps.evoshift.domain.model.OhsConfirmation
import com.evoapps.evoshift.domain.model.OhsGeneralMode
import com.evoapps.evoshift.domain.model.OhsPeriodicMode
import com.evoapps.evoshift.domain.model.OhsRecord
import com.evoapps.evoshift.domain.model.OhsRules
import com.evoapps.evoshift.domain.model.OhsWorkerGroup
import com.evoapps.evoshift.domain.repository.OhsDocumentKind
import com.evoapps.evoshift.ui.CardHairline
import com.evoapps.evoshift.ui.DeepNavy
import com.evoapps.evoshift.ui.WarningEdge
import com.evoapps.evoshift.ui.WarningSurface
import com.evoapps.evoshift.ui.adaptive.ContentMaxWidth
import com.evoapps.evoshift.ui.adaptive.LocalWindowWidthClass
import com.evoapps.evoshift.ui.adaptive.TwoPane
import com.evoapps.evoshift.ui.adaptive.WideContentMaxWidth
import com.evoapps.evoshift.ui.adaptive.contentWidth
import com.evoapps.evoshift.ui.documents.formatMoment
import com.evoapps.evoshift.ui.user.formatDay
import com.evoapps.evoshift.ui.util.HelpPage
import com.evoapps.evoshift.ui.util.asString
import com.evoapps.evoshift.viewmodels.OhsDialog
import com.evoapps.evoshift.viewmodels.OhsRecordUiState
import com.evoapps.evoshift.viewmodels.OhsRecordViewModel
import com.evoapps.evoshift.widgets.DialogAction
import com.evoapps.evoshift.widgets.DialogSection
import com.evoapps.evoshift.widgets.DialogWidth
import com.evoapps.evoshift.widgets.EvoDateField
import com.evoapps.evoshift.widgets.EvoDialog
import com.evoapps.evoshift.widgets.EvoSwitchRow
import com.evoapps.evoshift.widgets.EvoTextField
import com.evoapps.evoshift.widgets.EvoTopBar
import com.evoapps.evoshift.widgets.OnScreen
import com.evoapps.evoshift.widgets.SurfaceCard
import com.evoapps.evoshift.widgets.WarningNote
import com.evoapps.evoshift.widgets.helpAction
import evoshift.composeapp.generated.resources.Res
import evoshift.composeapp.generated.resources.ohs_admitted_on
import evoshift.composeapp.generated.resources.ohs_card_pdf
import evoshift.composeapp.generated.resources.ohs_certificate_number
import evoshift.composeapp.generated.resources.ohs_certificate_number_hint
import evoshift.composeapp.generated.resources.ohs_certificate_pdf
import evoshift.composeapp.generated.resources.ohs_change
import evoshift.composeapp.generated.resources.ohs_commission
import evoshift.composeapp.generated.resources.ohs_completed_on
import evoshift.composeapp.generated.resources.ohs_conducted_by
import evoshift.composeapp.generated.resources.ohs_conducted_on
import evoshift.composeapp.generated.resources.ohs_confirm
import evoshift.composeapp.generated.resources.ohs_confirm_general_statement
import evoshift.composeapp.generated.resources.ohs_confirm_station_statement
import evoshift.composeapp.generated.resources.ohs_confirm_title
import evoshift.composeapp.generated.resources.ohs_confirmed_on
import evoshift.composeapp.generated.resources.ohs_dates_done
import evoshift.composeapp.generated.resources.ohs_dates_missing
import evoshift.composeapp.generated.resources.ohs_documents
import evoshift.composeapp.generated.resources.ohs_exam_on
import evoshift.composeapp.generated.resources.ohs_field_admitted_by
import evoshift.composeapp.generated.resources.ohs_field_admitted_on
import evoshift.composeapp.generated.resources.ohs_field_certificate
import evoshift.composeapp.generated.resources.ohs_field_conducted_by
import evoshift.composeapp.generated.resources.ohs_field_conducted_on
import evoshift.composeapp.generated.resources.ohs_field_date
import evoshift.composeapp.generated.resources.ohs_field_exam_on
import evoshift.composeapp.generated.resources.ohs_field_form
import evoshift.composeapp.generated.resources.ohs_general
import evoshift.composeapp.generated.resources.ohs_general_in_person
import evoshift.composeapp.generated.resources.ohs_general_missing
import evoshift.composeapp.generated.resources.ohs_general_online
import evoshift.composeapp.generated.resources.ohs_group
import evoshift.composeapp.generated.resources.ohs_group_unknown
import evoshift.composeapp.generated.resources.ohs_initial
import evoshift.composeapp.generated.resources.ohs_intro
import evoshift.composeapp.generated.resources.ohs_not_signature
import evoshift.composeapp.generated.resources.ohs_organizer
import evoshift.composeapp.generated.resources.ohs_owner_text
import evoshift.composeapp.generated.resources.ohs_owner_title
import evoshift.composeapp.generated.resources.ohs_periodic
import evoshift.composeapp.generated.resources.ohs_periodic_elsewhere
import evoshift.composeapp.generated.resources.ohs_periodic_missing
import evoshift.composeapp.generated.resources.ohs_periodic_test_passed
import evoshift.composeapp.generated.resources.ohs_position
import evoshift.composeapp.generated.resources.ohs_record_complete
import evoshift.composeapp.generated.resources.ohs_record_exam
import evoshift.composeapp.generated.resources.ohs_record_general
import evoshift.composeapp.generated.resources.ohs_record_incomplete
import evoshift.composeapp.generated.resources.ohs_record_station
import evoshift.composeapp.generated.resources.ohs_record_title
import evoshift.composeapp.generated.resources.ohs_record_title_of
import evoshift.composeapp.generated.resources.ohs_save
import evoshift.composeapp.generated.resources.ohs_settings
import evoshift.composeapp.generated.resources.ohs_station
import evoshift.composeapp.generated.resources.ohs_station_missing
import evoshift.composeapp.generated.resources.ohs_station_not_required
import evoshift.composeapp.generated.resources.ohs_station_required
import evoshift.composeapp.generated.resources.ohs_station_required_hint
import evoshift.composeapp.generated.resources.ohs_status_done
import evoshift.composeapp.generated.resources.ohs_status_missing
import evoshift.composeapp.generated.resources.ohs_status_not_required
import evoshift.composeapp.generated.resources.ohs_status_to_confirm
import evoshift.composeapp.generated.resources.ohs_waiting_confirmation
import org.jetbrains.compose.resources.stringResource

/**
 * SH-126: a person's OHS training record, the electronic side of the karta szkolenia wstępnego
 * and the periodic training. Managers record what happened in person (general instruction held
 * in person, the workplace instruction with the test and admission, the exam before the
 * commission, training done elsewhere); the person confirms the instructions; the OHS date is set
 * only once every required part is done. Both print the karta and the zaświadczenie (PDF).
 *
 * SH-244: the result on top, then each part as a card with its status, its facts as labelled
 * values and its actions as filled buttons; on wide windows the initial training on the left and
 * the position group, periodic training and documents on the right. The owner is the employer and
 * gets a note instead of a record.
 */
@Composable
fun OhsRecordScreen(viewModel: OhsRecordViewModel, onNavigateBack: () -> Unit) {
    val state by viewModel.uiState.collectAsStateWithLifecycle()
    val snackbarHostState = remember { SnackbarHostState() }
    val shown = (state.error ?: state.message)?.asString()
    LaunchedEffect(shown) {
        shown?.let {
            snackbarHostState.showSnackbar(it)
            viewModel.messageShown()
        }
    }
    val uriHandler = LocalUriHandler.current
    LaunchedEffect(state.openUrl) {
        state.openUrl?.let {
            uriHandler.openUri(it)
            viewModel.urlOpened()
        }
    }
    var confirming by remember { mutableStateOf<OhsConfirmation?>(null) }

    Scaffold(
        snackbarHost = { SnackbarHost(snackbarHostState) },
        topBar = {
            EvoTopBar(
                title = if (state.isMine) stringResource(Res.string.ohs_record_title) else stringResource(Res.string.ohs_record_title_of, state.personName),
                onBack = onNavigateBack,
                actions = listOf(helpAction(HelpPage.OHS_TRAINING))
            )
        }
    ) { padding ->
        Box(Modifier.padding(padding).fillMaxSize()) {
            if (state.isLoading) {
                CircularProgressIndicator(Modifier.align(Alignment.Center))
                return@Box
            }
            if (!state.canSee) return@Box
            val wide = LocalWindowWidthClass.current.isExpanded
            val gap = if (wide) 24.dp else 16.dp
            Column(
                modifier = Modifier.fillMaxSize().verticalScroll(rememberScrollState())
                    .contentWidth(if (wide) WideContentMaxWidth else ContentMaxWidth)
                    .padding(gap),
                verticalArrangement = Arrangement.spacedBy(gap)
            ) {
                val record = state.record
                if (state.isOwner) {
                    // SH-244: the employer takes no initial training, but the periodic one.
                    OwnerNote()
                    TwoPane(
                        modifier = Modifier.fillMaxWidth(),
                        firstWeight = 0.56f,
                        spacing = gap,
                        first = {
                            PeriodicPart(
                                state, record,
                                onExam = { viewModel.open(OhsDialog.PeriodicExam()) },
                                onElsewhere = { viewModel.open(OhsDialog.PeriodicElsewhere()) }
                            )
                        },
                        second = {
                            Column(verticalArrangement = Arrangement.spacedBy(16.dp)) {
                                SettingsPart(state, record, onChange = { viewModel.open(OhsDialog.Settings(record?.group, false)) })
                                DocumentsPart(state, record, onDocument = viewModel::document)
                            }
                        }
                    )
                    return@Column
                }
                ResultBanner(record)
                TwoPane(
                    modifier = Modifier.fillMaxWidth(),
                    firstWeight = 0.56f,
                    spacing = gap,
                    first = {
                        Column(verticalArrangement = Arrangement.spacedBy(16.dp)) {
                            Text(stringResource(Res.string.ohs_initial), style = MaterialTheme.typography.titleLarge, fontWeight = FontWeight.Bold)
                            Text(stringResource(Res.string.ohs_intro), style = MaterialTheme.typography.bodyMedium, color = OnScreen.onSurfaceVariant)
                            GeneralPart(state, record, onRecord = { viewModel.open(OhsDialog.GeneralInPerson()) }, onConfirm = { confirming = OhsConfirmation.GENERAL })
                            StationPart(state, record, onRecord = { viewModel.open(OhsDialog.Station()) }, onConfirm = { confirming = OhsConfirmation.STATION })
                        }
                    },
                    second = {
                        Column(verticalArrangement = Arrangement.spacedBy(16.dp)) {
                            SettingsPart(state, record, onChange = { viewModel.open(OhsDialog.Settings(record?.group, record?.stationRequired ?: true)) })
                            PeriodicPart(
                                state, record,
                                onExam = { viewModel.open(OhsDialog.PeriodicExam()) },
                                onElsewhere = { viewModel.open(OhsDialog.PeriodicElsewhere()) }
                            )
                            DocumentsPart(state, record, onDocument = viewModel::document)
                            Text(stringResource(Res.string.ohs_not_signature), style = MaterialTheme.typography.bodySmall, color = OnScreen.onSurfaceVariant)
                        }
                    }
                )
            }
        }
    }

    confirming?.let { part ->
        EvoDialog(
            title = stringResource(Res.string.ohs_confirm_title),
            icon = Icons.Default.CheckCircle,
            onDismiss = { confirming = null },
            width = DialogWidth.Compact,
            confirm = DialogAction(stringResource(Res.string.ohs_confirm), { confirming = null; viewModel.confirm(part) })
        ) {
            val record = state.record
            Text(
                if (part == OhsConfirmation.GENERAL) stringResource(Res.string.ohs_confirm_general_statement, record?.general?.conductedBy.orEmpty())
                else stringResource(Res.string.ohs_confirm_station_statement, record?.station?.position.orEmpty(), record?.station?.conductedBy.orEmpty()),
                color = Color.White.copy(alpha = 0.9f)
            )
            Text(stringResource(Res.string.ohs_not_signature), color = Color.White.copy(alpha = 0.65f), style = MaterialTheme.typography.bodySmall)
        }
    }

    state.dialog?.let { dialog -> RecordDialog(dialog, state.isSaving, viewModel) }
}

/**
 * SH-244: who records the position group and the periodic training here: managers for others, and
 * the owner for themselves too (the employer keeps their own periodic training).
 */
private val OhsRecordUiState.recordsPeriodic: Boolean get() = canRecord && (!isMine || isOwner)

/** SH-244: where a part of the training stands, shown as a chip on its card. */
internal enum class OhsPartStatus { DONE, TO_CONFIRM, MISSING, NOT_REQUIRED }

/** SH-244: the general instruction's status. */
internal fun generalStatus(record: OhsRecord?): OhsPartStatus {
    val general = record?.general ?: return OhsPartStatus.MISSING
    return if (general.employeeConfirmedAt == null) OhsPartStatus.TO_CONFIRM else OhsPartStatus.DONE
}

/** SH-244: the workplace instruction's status. */
internal fun stationStatus(record: OhsRecord?): OhsPartStatus {
    if (record?.stationRequired == false) return OhsPartStatus.NOT_REQUIRED
    val station = record?.station ?: return OhsPartStatus.MISSING
    return if (station.employeeConfirmedAt == null) OhsPartStatus.TO_CONFIRM else OhsPartStatus.DONE
}

private val DoneSurface = Color(0xFFE8F5E9)

@Composable
private fun StatusChip(status: OhsPartStatus) {
    val (label, background, color) = when (status) {
        OhsPartStatus.DONE -> Triple(Res.string.ohs_status_done, DoneSurface, OnScreen.success)
        OhsPartStatus.TO_CONFIRM -> Triple(Res.string.ohs_status_to_confirm, WarningSurface, OnScreen.warning)
        OhsPartStatus.MISSING -> Triple(Res.string.ohs_status_missing, CardHairline, OnScreen.onSurfaceVariant)
        OhsPartStatus.NOT_REQUIRED -> Triple(Res.string.ohs_status_not_required, CardHairline, OnScreen.onSurfaceVariant)
    }
    Text(
        stringResource(label),
        style = MaterialTheme.typography.labelMedium,
        color = color,
        fontWeight = FontWeight.Bold,
        modifier = Modifier.clip(RoundedCornerShape(8.dp)).background(background).padding(horizontal = 10.dp, vertical = 4.dp)
    )
}

/** The OHS result: done with its dates (green), or what is still missing (amber). */
@Composable
private fun ResultBanner(record: OhsRecord?) {
    val dates = record?.let { OhsRules.dates(it) }
    val done = dates != null
    Row(
        modifier = Modifier.fillMaxWidth()
            .clip(RoundedCornerShape(16.dp))
            .background(if (done) DoneSurface else WarningSurface)
            .border(1.dp, if (done) OnScreen.success.copy(alpha = 0.35f) else WarningEdge, RoundedCornerShape(16.dp))
            .padding(20.dp),
        verticalAlignment = Alignment.CenterVertically
    ) {
        Icon(
            if (done) Icons.Default.CheckCircle else Icons.Default.HealthAndSafety,
            contentDescription = null,
            tint = if (done) OnScreen.success else OnScreen.warning,
            modifier = Modifier.size(36.dp)
        )
        Spacer(Modifier.width(16.dp))
        Column(verticalArrangement = Arrangement.spacedBy(4.dp)) {
            Text(
                stringResource(if (done) Res.string.ohs_record_complete else Res.string.ohs_record_incomplete),
                style = MaterialTheme.typography.titleMedium,
                fontWeight = FontWeight.Bold,
                color = if (done) OnScreen.success else OnScreen.warning
            )
            Text(
                if (dates != null) stringResource(Res.string.ohs_dates_done, formatDay(dates.completedOn), formatDay(dates.validUntil))
                else stringResource(Res.string.ohs_dates_missing),
                style = MaterialTheme.typography.bodyMedium,
                color = DeepNavy
            )
        }
    }
}

@Composable
private fun OwnerNote() {
    SurfaceCard(Modifier.fillMaxWidth()) {
        Row(Modifier.padding(20.dp), verticalAlignment = Alignment.Top) {
            Icon(Icons.Default.Info, contentDescription = null, tint = MaterialTheme.colorScheme.primary, modifier = Modifier.size(28.dp))
            Spacer(Modifier.width(16.dp))
            Column(verticalArrangement = Arrangement.spacedBy(8.dp)) {
                Text(stringResource(Res.string.ohs_owner_title), style = MaterialTheme.typography.titleMedium, fontWeight = FontWeight.Bold)
                Text(stringResource(Res.string.ohs_owner_text), style = MaterialTheme.typography.bodyMedium)
            }
        }
    }
}

@Composable
private fun PartCard(title: String, icon: ImageVector, status: OhsPartStatus?, content: @Composable ColumnScope.() -> Unit) {
    SurfaceCard(Modifier.fillMaxWidth(), warning = status == OhsPartStatus.TO_CONFIRM) {
        Column(Modifier.padding(20.dp), verticalArrangement = Arrangement.spacedBy(14.dp)) {
            Row(verticalAlignment = Alignment.CenterVertically) {
                Icon(icon, contentDescription = null, tint = MaterialTheme.colorScheme.primary, modifier = Modifier.size(22.dp))
                Spacer(Modifier.width(10.dp))
                Text(title, style = MaterialTheme.typography.titleMedium, fontWeight = FontWeight.Bold, modifier = Modifier.weight(1f))
                if (status != null) {
                    Spacer(Modifier.width(8.dp))
                    StatusChip(status)
                }
            }
            content()
        }
    }
}

/** The facts of a part as labelled values, two to a row. */
@Composable
private fun Facts(vararg facts: Pair<String, String>) {
    FlowRow(
        modifier = Modifier.fillMaxWidth(),
        maxItemsInEachRow = 2,
        horizontalArrangement = Arrangement.spacedBy(16.dp),
        verticalArrangement = Arrangement.spacedBy(12.dp)
    ) {
        facts.forEach { (label, value) ->
            Column(Modifier.weight(1f), verticalArrangement = Arrangement.spacedBy(2.dp)) {
                Text(label, style = MaterialTheme.typography.labelMedium, color = OnScreen.onSurfaceVariant)
                Text(value, style = MaterialTheme.typography.bodyLarge, fontWeight = FontWeight.Medium)
            }
        }
    }
}

/** A plain explanation inside a card. */
@Composable
private fun Note(text: String) {
    Text(text, style = MaterialTheme.typography.bodyMedium, color = OnScreen.onSurfaceVariant)
}

/** A card's buttons in one row (wrapping on a narrow phone). */
@Composable
private fun Actions(content: @Composable () -> Unit) {
    FlowRow(
        modifier = Modifier.fillMaxWidth(),
        horizontalArrangement = Arrangement.spacedBy(8.dp),
        verticalArrangement = Arrangement.spacedBy(8.dp)
    ) { content() }
}

/** The main action of a card: a filled button. */
@Composable
private fun PrimaryAction(label: String, icon: ImageVector? = null, enabled: Boolean = true, onClick: () -> Unit) {
    Button(onClick = onClick, enabled = enabled, contentPadding = PaddingValues(horizontal = 20.dp, vertical = 10.dp)) {
        if (icon != null) {
            Icon(icon, contentDescription = null, modifier = Modifier.size(18.dp))
            Spacer(Modifier.width(8.dp))
        }
        Text(label)
    }
}

/** A secondary action: an outlined button. */
@Composable
private fun SecondaryAction(label: String, icon: ImageVector? = null, onClick: () -> Unit) {
    OutlinedButton(onClick = onClick, contentPadding = PaddingValues(horizontal = 20.dp, vertical = 10.dp)) {
        if (icon != null) {
            Icon(icon, contentDescription = null, modifier = Modifier.size(18.dp))
            Spacer(Modifier.width(8.dp))
        }
        Text(label)
    }
}

/** The employee's confirmation: when, or waiting (with the button for the employee). */
@Composable
private fun Confirmation(at: kotlin.time.Instant?, isMine: Boolean, onConfirm: () -> Unit) {
    if (at != null) {
        Row(verticalAlignment = Alignment.CenterVertically) {
            Icon(Icons.Default.CheckCircle, contentDescription = null, tint = OnScreen.success, modifier = Modifier.size(18.dp))
            Spacer(Modifier.width(8.dp))
            Text(stringResource(Res.string.ohs_confirmed_on, formatMoment(at)), style = MaterialTheme.typography.bodyMedium, color = OnScreen.success)
        }
    } else {
        WarningNote(stringResource(Res.string.ohs_waiting_confirmation))
        if (isMine) Actions { PrimaryAction(stringResource(Res.string.ohs_confirm), Icons.Default.CheckCircle, onClick = onConfirm) }
    }
}

@Composable
private fun SettingsPart(state: OhsRecordUiState, record: OhsRecord?, onChange: () -> Unit) {
    PartCard(stringResource(Res.string.ohs_settings), Icons.Default.Badge, status = null) {
        Facts(stringResource(Res.string.ohs_group) to stringResource(record?.group?.label() ?: Res.string.ohs_group_unknown))
        if (!state.isOwner) Note(stringResource(if (record?.stationRequired == false) Res.string.ohs_station_not_required else Res.string.ohs_station_required))
        if (state.recordsPeriodic) Actions { SecondaryAction(stringResource(Res.string.ohs_change), Icons.Default.Edit, onChange) }
    }
}

@Composable
private fun GeneralPart(state: OhsRecordUiState, record: OhsRecord?, onRecord: () -> Unit, onConfirm: () -> Unit) {
    PartCard(stringResource(Res.string.ohs_general), Icons.Default.School, generalStatus(record)) {
        val general = record?.general
        if (general == null) {
            Note(stringResource(Res.string.ohs_general_missing))
        } else {
            val courseTitle = general.courseTitle
            val score = general.score
            val form = when {
                general.mode == OhsGeneralMode.IN_PERSON -> stringResource(Res.string.ohs_general_in_person)
                courseTitle != null && score != null -> stringResource(Res.string.ohs_general_online, courseTitle, score)
                else -> null
            }
            Facts(
                *listOfNotNull(
                    stringResource(Res.string.ohs_field_conducted_by) to general.conductedBy,
                    stringResource(Res.string.ohs_field_date) to formatDay(general.completedOn),
                    form?.let { stringResource(Res.string.ohs_field_form) to it }
                ).toTypedArray()
            )
            Confirmation(general.employeeConfirmedAt, state.isMine, onConfirm)
        }
        if (state.canRecord && !state.isMine) Actions { PrimaryAction(stringResource(Res.string.ohs_record_general), Icons.Default.EditNote, onClick = onRecord) }
    }
}

@Composable
private fun StationPart(state: OhsRecordUiState, record: OhsRecord?, onRecord: () -> Unit, onConfirm: () -> Unit) {
    PartCard(stringResource(Res.string.ohs_station), Icons.Default.Engineering, stationStatus(record)) {
        if (record?.stationRequired == false) {
            Note(stringResource(Res.string.ohs_station_not_required))
            return@PartCard
        }
        val station = record?.station
        if (station == null) {
            Note(stringResource(Res.string.ohs_station_missing))
        } else {
            Facts(
                *listOfNotNull(
                    stringResource(Res.string.ohs_position) to station.position,
                    stringResource(Res.string.ohs_field_conducted_by) to station.conductedBy,
                    stringResource(Res.string.ohs_field_conducted_on) to formatDay(station.conductedOn),
                    stringResource(Res.string.ohs_field_admitted_on) to formatDay(station.admittedOn),
                    station.recordedByName?.takeIf { it.isNotBlank() }?.let { stringResource(Res.string.ohs_field_admitted_by) to it }
                ).toTypedArray()
            )
            Confirmation(station.employeeConfirmedAt, state.isMine, onConfirm)
        }
        if (state.canRecord && !state.isMine) Actions { PrimaryAction(stringResource(Res.string.ohs_record_station), Icons.Default.EditNote, onClick = onRecord) }
    }
}

@Composable
private fun PeriodicPart(state: OhsRecordUiState, record: OhsRecord?, onExam: () -> Unit, onElsewhere: () -> Unit) {
    val periodic = record?.periodic
    val done = record?.periodicDone == true
    PartCard(
        stringResource(Res.string.ohs_periodic), Icons.Default.Autorenew,
        status = when {
            done -> OhsPartStatus.DONE
            periodic == null -> OhsPartStatus.MISSING
            else -> null
        }
    ) {
        when {
            periodic == null -> Note(stringResource(Res.string.ohs_periodic_missing))
            done -> Facts(
                *listOfNotNull(
                    periodic.examOn?.let { stringResource(Res.string.ohs_field_exam_on) to formatDay(it) },
                    stringResource(Res.string.ohs_field_certificate) to periodic.certificateNumber.orEmpty(),
                    if (periodic.mode == OhsPeriodicMode.SELF_STUDY) periodic.commission?.let { stringResource(Res.string.ohs_commission) to it }
                    else periodic.organizer?.let { stringResource(Res.string.ohs_organizer) to it }
                ).toTypedArray()
            )
            periodic.testPassedOn != null -> Note(stringResource(Res.string.ohs_periodic_test_passed, formatDay(periodic.testPassedOn!!), periodic.score ?: 0))
            else -> Note(stringResource(Res.string.ohs_periodic_missing))
        }
        if (state.recordsPeriodic) {
            Actions {
                if (periodic?.mode == OhsPeriodicMode.SELF_STUDY && periodic.testPassedOn != null && record.group?.maySelfStudy != false) {
                    PrimaryAction(stringResource(Res.string.ohs_record_exam), Icons.Default.EditNote, onClick = onExam)
                }
                SecondaryAction(stringResource(Res.string.ohs_periodic_elsewhere), onClick = onElsewhere)
            }
        }
    }
}

@Composable
private fun DocumentsPart(state: OhsRecordUiState, record: OhsRecord?, onDocument: (OhsDocumentKind) -> Unit) {
    // SH-244: the karta is the initial training's; an owner has none, only the certificate.
    val card = record != null && !state.isOwner && (record.general != null || record.station != null)
    val certificate = record != null && record.periodicDone && record.periodic?.mode == OhsPeriodicMode.SELF_STUDY
    if (!card && !certificate) return
    PartCard(stringResource(Res.string.ohs_documents), Icons.Default.Description, status = null) {
        Actions {
            if (card) PrimaryAction(stringResource(Res.string.ohs_card_pdf), Icons.Default.PictureAsPdf, enabled = state.opening == null) { onDocument(OhsDocumentKind.CARD) }
            if (certificate) {
                PrimaryAction(stringResource(Res.string.ohs_certificate_pdf), Icons.Default.PictureAsPdf, enabled = state.opening == null) { onDocument(OhsDocumentKind.CERTIFICATE) }
            }
        }
    }
}

@Composable
private fun RecordDialog(dialog: OhsDialog, saving: Boolean, viewModel: OhsRecordViewModel) {
    val title = stringResource(
        when (dialog) {
            is OhsDialog.Settings -> Res.string.ohs_settings
            is OhsDialog.GeneralInPerson -> Res.string.ohs_record_general
            is OhsDialog.Station -> Res.string.ohs_record_station
            is OhsDialog.PeriodicExam -> Res.string.ohs_record_exam
            is OhsDialog.PeriodicElsewhere -> Res.string.ohs_periodic_elsewhere
        }
    )
    EvoDialog(
        title = title,
        icon = Icons.Default.HealthAndSafety,
        onDismiss = viewModel::closeDialog,
        dismissOnClickOutside = false,
        confirm = DialogAction(stringResource(Res.string.ohs_save), viewModel::save, enabled = viewModel.entryOf(dialog) != null, loading = saving)
    ) {
        when (dialog) {
            is OhsDialog.Settings -> {
                DialogSection(stringResource(Res.string.ohs_group)) {
                    OhsWorkerGroup.entries.forEach { group ->
                        Row(
                            Modifier.fillMaxWidth().selectable(selected = dialog.group == group, role = Role.RadioButton, onClick = { viewModel.edit(dialog.copy(group = group)) }),
                            verticalAlignment = Alignment.CenterVertically
                        ) {
                            RadioButton(selected = dialog.group == group, onClick = null)
                            Spacer(Modifier.width(8.dp))
                            Text(stringResource(group.label()), color = Color.White)
                        }
                    }
                }
                EvoSwitchRow(
                    checked = dialog.stationRequired || dialog.group == OhsWorkerGroup.BLUE_COLLAR,
                    onCheckedChange = { viewModel.edit(dialog.copy(stationRequired = it)) },
                    label = stringResource(Res.string.ohs_station_required),
                    supporting = stringResource(Res.string.ohs_station_required_hint),
                    enabled = dialog.group != OhsWorkerGroup.BLUE_COLLAR
                )
            }
            is OhsDialog.GeneralInPerson -> {
                EvoTextField(dialog.conductedBy, { viewModel.edit(dialog.copy(conductedBy = it)) }, stringResource(Res.string.ohs_conducted_by))
                EvoDateField(dialog.completedOn, { viewModel.edit(dialog.copy(completedOn = it)) }, stringResource(Res.string.ohs_completed_on))
            }
            is OhsDialog.Station -> {
                EvoTextField(dialog.position, { viewModel.edit(dialog.copy(position = it)) }, stringResource(Res.string.ohs_position))
                EvoTextField(dialog.conductedBy, { viewModel.edit(dialog.copy(conductedBy = it)) }, stringResource(Res.string.ohs_conducted_by))
                EvoDateField(dialog.conductedOn, { viewModel.edit(dialog.copy(conductedOn = it)) }, stringResource(Res.string.ohs_conducted_on))
                EvoDateField(dialog.admittedOn, { viewModel.edit(dialog.copy(admittedOn = it)) }, stringResource(Res.string.ohs_admitted_on))
            }
            is OhsDialog.PeriodicExam -> {
                EvoDateField(dialog.examOn, { viewModel.edit(dialog.copy(examOn = it)) }, stringResource(Res.string.ohs_exam_on))
                EvoTextField(dialog.commission, { viewModel.edit(dialog.copy(commission = it)) }, stringResource(Res.string.ohs_commission))
                EvoTextField(
                    dialog.certificateNumber, { viewModel.edit(dialog.copy(certificateNumber = it)) }, stringResource(Res.string.ohs_certificate_number),
                    supportingText = stringResource(Res.string.ohs_certificate_number_hint)
                )
            }
            is OhsDialog.PeriodicElsewhere -> {
                EvoDateField(dialog.examOn, { viewModel.edit(dialog.copy(examOn = it)) }, stringResource(Res.string.ohs_exam_on))
                EvoTextField(dialog.organizer, { viewModel.edit(dialog.copy(organizer = it)) }, stringResource(Res.string.ohs_organizer))
                EvoTextField(dialog.certificateNumber, { viewModel.edit(dialog.copy(certificateNumber = it)) }, stringResource(Res.string.ohs_certificate_number))
            }
        }
    }
}
